export default "__VITE_ASSET__ClG6QZPu__"